import { render, staticRenderFns } from "./SubQuestion.vue?vue&type=template&id=2af5abd0&scoped=true&"
import script from "./SubQuestion.vue?vue&type=script&lang=js&"
export * from "./SubQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SubQuestion.vue?vue&type=style&index=0&id=2af5abd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af5abd0",
  null
  
)

export default component.exports